import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Breakpoints } from '@zocdoc/components/src/grid';

export class CrazyEgg extends PureComponent {
    static propTypes = {
        MobileSnapshotName: PropTypes.string.isRequired,
        TabletSnapshotName: PropTypes.string.isRequired,
        DesktopSnapshotName: PropTypes.string.isRequired,
    };

    render() {
        return (<div></div>);
    }

    componentDidMount() {
        if (window.innerWidth < Breakpoints.small) {
            this.injectSnapshotNameScript(this.props.MobileSnapshotName);
        } else if (window.innerWidth < Breakpoints.medium) {
            this.injectSnapshotNameScript(this.props.TabletSnapshotName);
        } else {
            this.injectSnapshotNameScript(this.props.DesktopSnapshotName);
        }
    }

    injectSnapshotNameScript = snapshotName => {
        const snapshotNameScriptInnerHtml = `var CE_SNAPSHOT_NAME = "${snapshotName}";`;
        const snapshotNameScript = document.createElement('script');
        snapshotNameScript.innerHTML = snapshotNameScriptInnerHtml;

        document.body.appendChild(snapshotNameScript);
    };
}
